<template>
    <div class="mobile-sidebar" v-if="setup != null" :class="{'open' : openSendwich}">
        <div class="sidebar-content">
            <ul class="list-unstyled nav">
                <li v-for="(item, index) in setup.nav_burger" class="parent-link" :data-link="item.link" :key="index" :class="{open : currentIndex == index, 'sales-link' : item.link == '/sales'}" v-if="item.link != '/questions-answers'">
                    <a link="#" @click.prevent="setCurrentIndex(index, item.dropdown, item.link)" class="category-link">
                        <span>{{item.category}}</span>
                        <div class="nav-icon" v-if="item.dropdown != false && item.link != '/about'">
                            <svgIcon name="arrow-down" class="icon-arrow-down"/>
                        </div>
                    </a>
                    <slide-up-down :active="currentIndex == index" :duration="400" v-if="item.dropdown != false && item.link != '/about'" class="dropdown-menu">
                        <ul>
                            <li v-for="link in item.dropdown">
                                <router-link :to="link.href" @click.native="closeMobileMenu">{{link.name}}</router-link>
                            </li>
                        </ul>
                    </slide-up-down>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import SlideUpDown from 'vue-slide-up-down'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    import {mapGetters} from 'vuex'
    export default {
        name: 'mobile-sidebar',
        data () {
            return {
                currentIndex: 0,
            }
        },
        components: {
            SlideUpDown,
            svgIcon,
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
            openSendwich: 'loadOpenSendwich',
        }),
        methods: {
            setCurrentIndex(index, drop, link) {
                if (drop != false && link != '/about') {
                    if (this.currentIndex == index) {
                        this.currentIndex = null;
                    } else {
                        this.currentIndex = index
                    }
                } else {
                    this.currentIndex = null;
                    this.$router.push(link);
                    this.closeMobileMenu();
                }
            },
            closeMobileMenu() {
                this.$store.commit('Open_Sendwich', false);
                document.getElementsByTagName('body')[0].classList.toggle('overlay-open');
            },
        },
        created() {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/mobile-sidebar/mobile-sidebar.scss';
</style>